import React, { useEffect, useState } from 'react';
import { listingImageUrl, ListingImageSize } from '../utils/listingImageUrl';

type ListingImageProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  src: string | null | undefined;
  size?: ListingImageSize;
};

/** img that uses a resized display URL, falling back to the original on error. */
const ListingImage: React.FC<ListingImageProps> = ({
  src,
  size = 'card',
  alt = '',
  onError,
  ...rest
}) => {
  const original = (src || '').trim();
  const optimized = listingImageUrl(original, size);
  const [current, setCurrent] = useState(optimized || original);

  useEffect(() => {
    setCurrent(optimized || original);
  }, [optimized, original]);

  if (!original) return null;

  return (
    <img
      {...rest}
      src={current}
      alt={alt}
      onError={(e) => {
        if (current !== original && original) {
          setCurrent(original);
        }
        onError?.(e);
      }}
    />
  );
};

export default ListingImage;
